module.exports = __webpack_public_path__ + "static/media/instructivofin.e3a56a28.png";